import { inject, InjectionToken } from '@angular/core';

export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>('config');

export interface NpsCampaignSimulatorConfig {
  campaignActive: boolean;
  campaignName: string;
  campaignDescription: string;
}

export interface EnvironmentConfig {
  toolLibraryBaseApiUrl:
    | 'https://bff-library.toolhivesolutions.com'
    | 'https://bff-library-test.toolhivesolutions.com'
    | 'https://bff-library-dev.toolhivesolutions.com';
  version: string;
  nps?: {
    simulator?: NpsCampaignSimulatorConfig;
  };
}

const PROD_API_URL = 'https://bff-library.toolhivesolutions.com';

export function isNonProdEnvironment(): boolean {
  return inject(ENVIRONMENT_CONFIG).toolLibraryBaseApiUrl !== PROD_API_URL;
}
